import Vue from "vue";
import axios from "axios";
import store from "@/store";
import VueRouter from "vue-router";
import Login from "@/components/Login.vue";
import Dashboard from "@/components/Dashboard.vue";

const Users = () => import("@/views/Users/User.vue");
const Roles = () => import("@/views/roles/roles.vue");
const Permisos = () => import("@/views/permisos/permisos.vue");
const Especialidades = () => import("@/views/especialidades/especialidades.vue");
const Juzgados = () => import("@/views/juzgados/juzgados.vue");
// const Peritos = () => import("@/views/peritos/perfil.vue");
const PeritoShow = () => import("@/views/peritos/show.vue");
const Solicitudes = () => import("@/views/peritos/solicitudes.vue");
const Solicitud = () => import("@/views/peritos/solicitud.vue");
const Cedula = () => import("@/views/peritos/cedulas.vue");
const Generales = () => import("@/views/peritos/generales.vue");
const Partido = () => import("@/views/peritos/partidos.vue");
const PeritoEspecialidad = () => import("@/views/peritos/especializacion.vue");
const Domicilios = () => import("@/views/peritos/domicilios.vue");
const Telefonos = () => import("@/views/peritos/telefonos.vue");
const Carreras = () => import("@/views/peritos/carreras.vue");

const Informes = () => import("@/views/Informes/list.vue");
// const Perfil = () => import("@/views/peritos/perfil.vue");
const Documento = () => import("@/views/peritos/documentos.vue");

const Centros = () => import("@/views/Centros/Centros.vue");
const Log = () => import("@/views/logs/log.vue");

const Initial = () => import("@/views/Initial.vue");
const UpdatePassword = () => import("@/components/UpdatePassword");
const Refrendo = () => import("@/views/peritos/Refrendo.vue");
const Extemporaneo = () => import("@/views/peritos/extemporaneo.vue");
const Reporte = () => import("@/views/peritos/reporte.vue");
const ReporteInformes = () => import("@/views/Informes/reporteInformes.vue");
const Cuatrimestres = () => import("@/views/cuatrimestres/cuatrimestres.vue");
const ResetPassword = () => import("@/views/ResetPassword.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
    alias: "/login"
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
    meta: { public: true },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/initial",
    name: "Initial",
    component: Initial,
    meta: { authorize: ['superadmin', 'admin', 'perito'] }
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: { authorize: ['superadmin', 'admin'] }
  },
  {
    path: "/roles",
    name: "Roles",
    component: Roles,
    meta: { authorize: ['superadmin'] }
  },
  {
    path: "/permisos",
    name: "Permisos",
    component: Permisos,
    meta: { authorize: ['superadmin'] }
  },
  {
    path: "/especialidades",
    name: "Especialidades",
    component: Especialidades,
    meta: { authorize: ['superadmin', 'admin'] }
  },
  {
    path: "/juzgados",
    name: "Juzgados",
    component: Juzgados,
    meta: { authorize: ['superadmin', 'admin'] }
  },
  {
    path: "/peritos",
    name: "Solicitudes",
    component: Solicitudes,
    meta: { authorize: ['superadmin', 'admin', 'visor'] }
  },
  {
    path: "/solicitud",
    name: "Solicitud",
    component: Solicitud,
    meta: { authorize: ['superadmin', 'admin', 'perito'] }
  },
  {
    path: "/cedulas",
    name: "Cedula",
    component: Cedula,
    meta: { authorize: ['superadmin', 'admin', 'perito'] }
  },
  {
    path: "/partidos",
    name: "Partido",
    component: Partido,
    meta: { authorize: ['superadmin', 'admin', 'perito','visor'] }
  },
  {
    path: "/especializacion",
    name: "PeritoEspecialidad",
    component: PeritoEspecialidad,
    meta: { authorize: ['superadmin', 'admin', 'perito','visor'] }
  },
  {
    path: "/domicilios",
    name: "Domicilios",
    component: Domicilios,
    meta: { authorize: ['superadmin', 'admin', 'perito'] }
  },
  {
    path: "/telefonos",
    name: "Telefonos",
    component: Telefonos,
    meta: { authorize: ['superadmin', 'admin', 'perito'] }
  },
  {
    path: "/carreras",
    name: "Carreras",
    component: Carreras,
    meta: { authorize: ['superadmin', 'admin', 'perito'] }
  },
  // {
  //   path: "/perfil",
  //   name: "Perfil",
  //   component: Perfil,
  //   meta: { authorize: ['superadmin', 'admin', 'perito'] }
  // },
  {
    path: "/documentos",
    name: "Documento",
    component: Documento,
    meta: { authorize: ['superadmin', 'admin', 'perito'] }
  },
  {
    path: "/perito/show",
    name: "PeritoShow",
    component: PeritoShow,
    props: true,
    meta: { authorize: ['superadmin', 'admin', 'perito', 'visor'] }
  },
  {
    path: "/generales",
    name: "Generales",
    component: Generales,
    props: true,
    meta: { authorize: ['superadmin', 'admin', 'perito', 'visor'] }
  },
  {
    path: "/informes",
    name: "Informes",
    component: Informes,
    meta: { authorize: ['superadmin', 'admin', 'perito', 'visor'] }
  },
  {
    path: "/updatepassword",
    name: "UpdatePassword",
    component: UpdatePassword,
    meta: { authorize: ['superadmin', 'admin', 'perito', 'visor'] }
  },
  {
    path: "/refrendo",
    name: "Refrendo",
    component: Refrendo,
    meta: { authorize: ['superadmin', 'admin', 'perito'] }
  },
  {
    path: "/extemporaneo",
    name: "Extemporaneo",
    component: Extemporaneo,
    meta: { authorize: ['superadmin'] }
  },
  {
    path: "/reporte/refrendos",
    name: "Reporte",
    component: Reporte,
    meta: { authorize: ['superadmin', 'admin', 'visor'] }
  },
  {
    path: "/reporte/informes",
    name: "ReporteInformes",
    component: ReporteInformes,
    meta: { authorize: ['superadmin', 'admin', 'visor'] }
  },
  {
    path: "/cuatrimestres",
    name: "Cuatrimestres",
    component: Cuatrimestres,
    meta: { authorize: ['superadmin'] }
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

async function fetchBackendUser(token) {
  try {
    const response = await axios.get(process.env.VUE_APP_BASE_URL + '/me', {
      headers: { Authorization: 'Bearer ' + token }
    });
    return response.data.data.user;
  } catch {
    return null;
  }
}

router.beforeEach(async (to, from, next) => {
  const { authorize } = to.meta;
  const user = JSON.parse(localStorage.getItem("user"));
  const token = localStorage.getItem("token") || '';

  // Rutas públicas (reset-password, etc.) — no requieren auth
  if (to.meta.public) {
    return next();
  }

  if (authorize) {
    // Si no hay sesión, mandar al login
    if (!user || !token) {
      return next({ path: "/" });
    }

    // Llamar al backend para obtener los datos reales del usuario
    const backendUser = await fetchBackendUser(token);

    if (!backendUser) {
      // Token inválido o expirado
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      store.commit("AUTH_SYNC", {});
      return next({ path: "/" });
    }

    // Sincronizar: si los datos del localStorage difieren del backend, sobreescribir
    // Preservar campos del frontend (periodo_selected, periodo_id, perito_id)
    const merged = {
      ...backendUser,
      periodo_selected: user.periodo_selected,
      periodo_id: user.periodo_id,
      perito_id: user.perito_id,
    };

    if (JSON.stringify(user) !== JSON.stringify(merged)) {
      localStorage.setItem("user", JSON.stringify(merged));
      store.commit("AUTH_SYNC", merged);
    }

    // Verificar roles con los datos frescos del backend
    if (authorize.length && !authorize.includes(backendUser.roles[0].name)) {
      return next({ path: "/initial" });
    }
  }

  if ((to.path === "/" || to.path === "/login") && user) {
    return next({ path: "/initial" });
  }
  next();
});

export default router;
